import { cn } from '@/lib/utils';

interface LogoLockupProps {
  size?: 'sm' | 'default' | 'lg';
  className?: string;
}

export function LogoLockup({ size = 'default', className }: LogoLockupProps) {
  const sizes = {
    sm: 'h-16',
    default: 'h-24',
    lg: 'h-32',
  };
  
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <img 
        src="https://res.cloudinary.com/dtc6oth0i/image/upload/v1764381854/Untitled_design_16_u0wnzl.png" 
        alt="SNOWBLOWR" 
        className={sizes[size]} 
      />
    </div>
  );
}

